import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import type { MovementPageData } from 'src/app/pages/movement/pageContext';
import { useMovementPageData } from 'src/app/pages/movement/pageContext';
import { useIsStaff } from 'src/app/shared/hooks/session';

type Result = ModelHookResult<
	{
		isStaff: boolean;
		movementId: string;
		movementSlug: string;
		owner: MovementPageData['movement']['owner'];
	},
	{
		handleEditPetitionsClick: () => void;
		handleAddPetitionsClick: () => void;
	}
>;

export function usePageAdminTools(): Result {
	const isStaff = useIsStaff();
	const track = useTracking();
	const {
		data: {
			movement: { id: movementId, slug, owner },
		},
	} = useMovementPageData();

	const handleEditPetitionsClick = useCallback(() => {
		const eventOptions = { movement_id: movementId, view_context: 'movement_show' };
		void track('movement_edit_click', eventOptions);
	}, [movementId, track]);

	const handleAddPetitionsClick = useCallback(() => {
		const eventOptions = { movement_id: movementId, view_context: 'movement_show' };
		void track('movement_add_petitions_click', eventOptions);
	}, [movementId, track]);

	return {
		data: {
			isStaff,
			movementId,
			movementSlug: slug,
			owner,
		},
		actions: {
			handleEditPetitionsClick,
			handleAddPetitionsClick,
		},
	};
}
